import React from "react";
import { Button } from 'reactstrap';
import { connect } from "react-redux";
import { load as loadAccount } from "../../../redux/reducers/commonReducer";
import { Field, reduxForm, load, getFormValues } from "redux-form";
import validate from "../../Validations/validate";
import showToasterMessage from '../../UI/ToasterMessage/toasterMessage';
import { withTranslation } from "react-i18next";
import moment from 'moment';
import DatePicker from '../../../shared/components/form/DatePicker';
import AutoComplete from '../../Form/components/AutoComplete';
import Select from '../../../shared/components/form/Select';
import fetchMethodRequest from '../../../config/service';
import Loader from '../../App/Loader';
import apiCalls from '../../../config/apiCalls';
import config from "../../../config/config";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect } from "react-router";


const required = value => value ? undefined : 'Required';
class OrdersEdit extends React.Component {

    scanTypes = [
        {
            "label": 'MRI',
            "value": 'MRI'

        },
        {
            "label": 'MRA',
            "value": 'MRA'

        },
        {
            "label": 'CT',
            "value": 'CT'

        },
        {
            "label": 'CTA',
            "value": 'CTA'

        },
        {
            "label": 'PET',
            "value": 'PET'

        },
        {
            "label": 'US',
            "value": 'US'

        }
    ]
    selectedScanTypes = {};
    appoinmentDetailsObj = {};
    orderDetailsT = {};

    constructor(props) {
        super(props);
        this.state = {
            scans: [],
            editRowDataID: '',
            orderDetails: {},
            statusOptions: [],
            slotTimes: {},
            isLoading: true,
            showTemplate: false,
            redirectToRoute:false,
            selectedFinancialClasses : {},
            provider:''
        }
    }



    componentDidMount = async () => { 
        if (this.props.pageType === 'edit') {
            if (this.props && this.props.data && this.props.data._id) {
                await this.setState({
                    editRowDataID: this.props.data._id
                });
            } else {
                let id = decodeURIComponent(window.location.pathname);
                id = id ? id.split('/') : '';
                if (id && id.length > 1) {
                    await this.setState({
                        editRowDataID: id[id.length - 1].slice(1, -1)
                    });
                }
            }
            const formFields = this.props.formFields();
            const indx = formFields.findIndex((form) => form.name === 'status');
            await this.setState({ statusOptions: (formFields[indx] && formFields[indx].options ? formFields[indx].options : []) });
            this.getOrderDetails();
        } else if (this.props.pageType === 'add') {
            let ordDet = {};
            ordDet['appoinmentDetails'] = [{
                "status": 'Created',
                "_id": 0               
            }];
            const formFields = this.props.formFields();
            const indx = formFields.findIndex((form) => form.name === 'status');
            await this.setState({ statusOptions: (formFields[indx] && formFields[indx].options ? formFields[indx].options : []) ,orderDetails: ordDet,showTemplate:true,isLoading:false});
            this.props.change(`status-0`, 'Created');
        }

    }

    getOrderDetails = () => {
        this.setState({ isLoading: true });
        fetchMethodRequest('GET', `${apiCalls.Orders}/${this.state.editRowDataID}`).then(async (res) => {
            if (res && res.details) {
                this.orderDetailsT = JSON.parse(JSON.stringify(res.details));
                await this.setState({ orderDetails: res.details });
                this.assignDataToForm(JSON.parse(JSON.stringify(this.state.orderDetails)));
            }
            this.setState({ isLoading: false });
        })
    }


    assignDataToForm = async (order) => {
        let loadObj = order;
        loadObj.patient = order.patient;
        loadObj.physician = order.physician;
        loadObj.provider = order.provider;
        loadObj.nextAppointment = order.nextAppointment;
        loadObj.phoneNumber = order.phoneNumber;
        loadObj.Npi = order.Npi;
        loadObj.phoneNumber = order.phoneNumber;
        loadObj.speciality = order.speciality;
        loadObj.note = order.note;

        if (order.scans && order.scans.length > 0) {
            order.scans.forEach((scan, i) => {
                scan['scanDetails'] = `${(scan.cptCode ? scan.cptCode : '')} - ${(scan.description ? scan.description : '')}`;
            });
        }

        if (order.appoinmentDetails && order.appoinmentDetails.length > 0) {
            let slotTimes = this.state.slotTimes;
            order.appoinmentDetails.forEach((appnt, i) => {
                slotTimes[`-${appnt._id}`] = []
                if (appnt.slotFromTime) {
                    let slot = {
                        scanType: appnt.slotModalities,
                        _id: appnt.slotId,
                        name: appnt.slotName,
                        date: appnt.slotDate,
                        fromTime: appnt.slotFromTime,
                        toTime: appnt.slotToTime
                    }

                    slotTimes[`-${appnt._id}`].push({
                        label: `${appnt.slotFromTime} - ${appnt.slotToTime}`,
                        value: JSON.stringify(slot)
                    });

                }
            });
            await this.setState({ slotTimes: slotTimes });

        }        



        if (order.appoinmentDetails && order.appoinmentDetails.length > 0) {
            let selectedFinancialClasses = {}
            order.appoinmentDetails.forEach((appnt, i) => {
                loadObj[`status-${appnt._id}`] = appnt.status;
                loadObj[`modalities-${appnt._id}`] = appnt.modalities;
                this.selectedScanTypes[`modalities-${appnt._id}`] = appnt.modalities;
                loadObj[`financialClass-${appnt._id}`] = appnt.financialClass;
                selectedFinancialClasses[`${appnt._id}`] = appnt.financialClass;
                if(appnt.financialClass === 'PIP' || appnt.financialClass === 'Slip & Fall' || appnt.financialClass === 'Workmans Comp'){                    
                    loadObj[`dateOfInjury-${appnt._id}`] = appnt.dateOfInjury;
                }
                if(appnt.financialClass === 'PIP'){
                    loadObj[`policyNumber-${appnt._id}`] = appnt.policyNumber;
                }
                loadObj[`priority-${appnt._id}`] = appnt.priority;
                loadObj[`facilityStaff-${appnt._id}`] = appnt.facilityStaff;
                loadObj[`scheduledDate-${appnt._id}`] = appnt.scheduledDate;
                loadObj[`scannedDate-${appnt._id}`] = appnt.scannedDate;
                loadObj[`reviewedDate-${appnt._id}`] = appnt.reviewedDate;
                loadObj[`completedDate-${appnt._id}`] = appnt.completedDate;
                loadObj[`notifiedDate-${appnt._id}`] = appnt.notifiedDate;
                loadObj[`slotDate-${appnt._id}`] = appnt.slotDate;
                loadObj[`slotModalities-${appnt._id}`] = appnt.slotModalities;
                loadObj[`note-${appnt._id}`] = appnt.note;
                loadObj[`scan-${appnt._id}`] = order.scans[i];
               
                    
                
                if (appnt.slotFromTime) {
                    let slot = {
                        scanType: appnt.modalities,
                        _id: appnt.slotId,
                        name: appnt.slotName,
                        date: appnt.slotDate,
                        fromTime: appnt.slotFromTime,
                        toTime: appnt.slotToTime
                    }
                    loadObj[`ScanTime-${appnt._id}`] = JSON.stringify(slot);
                    this.getSlotDetails(appnt.slotModalities, `${moment(appnt.scheduledDate).format('MM/DD/YYYY')} 00:00:00Z`, `-${appnt._id}`);
                }
            });

            await this.setState({selectedFinancialClasses:selectedFinancialClasses});
        }
        
        this.props.load(loadObj);
        
        this.setState({ showTemplate: true, isLoading: false });
        
        
    }

    onChange = (value, name) => {
        this.selectedScanTypes[name] = value;
    }

    handleDateChange = (name, value) => {
        
        const tarr = name.split('scheduledDate');
        if (tarr && tarr.length > 1) {
            if (this.selectedScanTypes[`modalities${tarr[1]}`]) {
                this.getSlotDetails(this.selectedScanTypes[`modalities${tarr[1]}`], `${moment(value).format('MM/DD/YYYY')} 00:00:00Z`, tarr[1]);
            } else {
                throw 'Select scan Type';
            }
        }

    }

    getSlotDetails = (scanType, date, id) => {
        console.log(id);
        this.setState({ isLoading: true });         
        fetchMethodRequest('GET', `${apiCalls.OpenSlots}?modalities=${scanType}&scheduledDate=${date}`).then(async (res) => {
            if (res && res.slotss && res.slotss.length > 0) {
                let slotTime = this.state.slotTimes
                const tempArrya = res.slotss.map((slot) => {
                    let ob = {};
                    ob['label'] = `${slot.fromTime} - ${slot.toTime}`;
                    ob['value'] = JSON.stringify(slot);
                    return ob;                    
                });
                if (slotTime[id] && slotTime[id].length === 1) {
                    slotTime[id] = slotTime[id].concat(tempArrya);
                } else {
                    slotTime[id] = tempArrya
                }
                console.log(tempArrya);
                await this.setState({ slotTimes: slotTime });

            }else {
                let slotTime = this.state.slotTimes;
                slotTime[id] = [];
                await this.setState({ slotTimes: slotTime });
            }
            this.setState({ isLoading: false });
        });
    }

    onClickAddScan = async () => {
        let orderDetails = this.state.orderDetails;
        let i = orderDetails.appoinmentDetails.length;
        orderDetails.appoinmentDetails.push({
            "status": 'Created',
            "_id": i
        });

        await this.setState({ orderDetails: orderDetails });
        this.props.change(`status-${i}`, 'Created');
    }

    onClickDeleteScan = (id,index) => {
        if (this.state.orderDetails.appoinmentDetails && this.state.orderDetails.appoinmentDetails.length > 1) {
            let orderDetails = this.state.orderDetails;
            orderDetails.appoinmentDetails.splice(index, 1);
            if (orderDetails.scans && orderDetails.scans.length > 0 && orderDetails.scans[index]) {
                orderDetails.scans.splice(index, 1);
            }         
            this.setState({ orderDetails: orderDetails });
        }
    }

    handleAutoCompleteData = (value, name) => {        
        if (name && name.toLowerCase() === 'physician') {
            this.props.change('Npi', value.NPI);
            this.props.change('speciality', value.speciality);
            this.props.change('phoneNumber', value.phoneNumber);
            this.props.change('fax', value.fax);
        } else if (name && (name.toLowerCase() === 'hospital' || name.toLowerCase() === 'provider')) {
            if (value && value._id) {
                this.setState({ provider: value._id });
            }
        }

    }

    onChangeFinancialClass = (e,id) => {
        let selecedVal = this.state.selectedFinancialClasses;
        selecedVal[id] = e;
        this.setState({selectedFinancialClasses:selecedVal});
    }

    submit = (values) => {
        this.state.orderDetails.appoinmentDetails.forEach((ap, i) => {
            if (values[`status-${ap._id}`] != 'Created' && values[`status-${ap._id}`] != 'Assigned') {
                if (!values[`modalities-${ap._id}`] || !values[`scheduledDate-${ap._id}`] || !values[`ScanTime-${ap._id}`]) {
                    throw 'Validation Failed';
                }
            }

        });

        let sendData = this.orderDetailsT;
        delete sendData.appoinmentDetails;
        delete sendData.scans;
        
        sendData.note = values.note;
        sendData.patient = values.patient;
        sendData.provider = values.provider;
        sendData.physician = values.physician;
        sendData.Npi = values.Npi;
        sendData.phoneNumber = values.phoneNumber;
        sendData.fax = values.fax;
        sendData.speciality = values.speciality;
        sendData.nextAppointment = values.nextAppointment;

        let appoinmentDetails = JSON.parse(JSON.stringify(this.state.orderDetails.appoinmentDetails));
        let scans = [];
        if (this.props.pageType === 'edit') {
            scans = JSON.parse(JSON.stringify(this.state.orderDetails.scans));
        }
        
        this.state.orderDetails.appoinmentDetails.forEach((ap, i) => {
            // console.log("`note-${ap._id}``note-${ap._id}`",`note-${ap._id}`)
            appoinmentDetails[i].note = values[`note-${ap._id}`];
            appoinmentDetails[i].status = values[`status-${ap._id}`];
            appoinmentDetails[i].modalities = values[`modalities-${ap._id}`];
            appoinmentDetails[i].financialClass = values[`financialClass-${ap._id}`];
            appoinmentDetails[i].facilityStaff = values[`facilityStaff-${ap._id}`];
            appoinmentDetails[i].facilityStaffName =  values[`facilityStaff-${ap._id}`]&&values[`facilityStaff-${ap._id}`].displayName ?values[`facilityStaff-${ap._id}`].displayName:"";           
            if(appoinmentDetails[i].financialClass === 'PIP'){
                appoinmentDetails[i].policyNumber = values[`policyNumber-${ap._id}`];
            } 
            if(appoinmentDetails[i].financialClass === 'PIP' || appoinmentDetails[i].financialClass === 'Slip & Fall' || appoinmentDetails[i].financialClass === 'Workmans Comp'){
                appoinmentDetails[i].dateOfInjury = values[`dateOfInjury-${ap._id}`];
            }           
            appoinmentDetails[i].priority = values[`priority-${ap._id}`];
            appoinmentDetails[i].scannedDate = values[`scannedDate-${ap._id}`];
            appoinmentDetails[i].scheduledDate = values[`scheduledDate-${ap._id}`];
            appoinmentDetails[i].reviewedDate = values[`reviewedDate-${ap._id}`];
            appoinmentDetails[i].completedDate = values[`completedDate-${ap._id}`];
            appoinmentDetails[i].notifiedDate = values[`notifiedDate-${ap._id}`];
            if (values[`modalities-${ap._id}`] && values[`scheduledDate-${ap._id}`] && values[`ScanTime-${ap._id}`]) {
                const scanDetails = JSON.parse(values[`ScanTime-${ap._id}`]);
                appoinmentDetails[i].slotModalities = scanDetails.modalities;
                // appoinmentDetails[i].modalities = scanDetails.modalities;
                appoinmentDetails[i].slotId = scanDetails._id;
                appoinmentDetails[i].slotName = scanDetails.name;
                appoinmentDetails[i].slotModalities = scanDetails.modalities;
                appoinmentDetails[i].slotDate = scanDetails.date;
                appoinmentDetails[i].slotScanTime = scanDetails.scanTime;
                appoinmentDetails[i].slotFromTime = scanDetails.fromTime;
                appoinmentDetails[i].slotToTime = scanDetails.toTime;
                appoinmentDetails[i].slotIsBooked = true;

            }
            scans[i] = values[`scan-${ap._id}`];
            if(!ap.order){
                appoinmentDetails[i].cptCode = values[`scan-${ap._id}`].cptCode;
                appoinmentDetails[i].scan = values[`scan-${ap._id}`]._id; 
                appoinmentDetails[i].scanCptCode = values[`scan-${ap._id}`].cptCode; 
                appoinmentDetails[i].description = values[`scan-${ap._id}`].description;   
                delete appoinmentDetails[i]._id;
            }

        });
        sendData.appoinmentDetails = appoinmentDetails;
        sendData.scans = scans;
        console.log(sendData);
        this.setState({
            isLoading: true
        });
        let loginDetails = (localStorage.getItem('loginCredentials') ? JSON.parse(localStorage.getItem('loginCredentials') ) : '' );
        sendData.facility = loginDetails && loginDetails.facility ? loginDetails.facility : '';
        const respCode = this.props.pageType === 'edit' ? 205 : 204 ;
        const method = this.props.pageType === 'edit' ? 'PUT' : 'POST';
        const api = this.props.pageType === 'edit' ? `${apiCalls.Orders}/${this.state.editRowDataID}` :  apiCalls.Orders;     
        fetchMethodRequest(method, api , sendData).then(async(res) => {
            if (res && res.respCode === respCode) {
                showToasterMessage(res.respMessage, 'success');                
                this.props.closeEdit();
                await this.setState({redirectToRoute:true});                
              
            } else if (res && res.errorMessage) {
                showToasterMessage(res.errorMessage, 'error');
            }
            this.setState({
                isLoading: false
            });
        }).catch((err) => {
            return err;
        });;
    }

    render() {
        return (

            <div className="card p-3 bg-white">
                <h4 ><b><a href="/orderss">Orders</a></b></h4>
                <div className="mt-4">
                    <Loader loader={this.state.isLoading} />
                    {this.state.showTemplate &&
                        <form onSubmit={this.props.handleSubmit(this.submit)}>
                            <div className="row form">
                                <div className="col-md-2">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                            Patient
                                        </label>
                                        <Field
                                            name='patient'
                                            searchApi={'patientss'}
                                            searchField={'displayName'}
                                            component={AutoComplete}
                                            validate={[required]}
                                            allow={false}
                                            handleAutoCompleteData={(event) => this.handleAutoCompleteData(event, 'patient')}
                                            type="text"
                                            disabled={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                            Provider
                                        </label>
                                        <Field
                                            name='provider'
                                            searchApi={'providerss'}
                                            searchField={'name'}
                                            component={AutoComplete}
                                            handleAutoCompleteData={(event) => this.handleAutoCompleteData(event, 'provider')}
                                            type="text"
                                            disabled={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                            Physician
                                        </label>
                                        <Field
                                            name='physician'
                                            searchApi={'provideremployees'}
                                            searchField={'displayName'}
                                            component={AutoComplete}
                                            provider={this.state.provider}
                                            handleAutoCompleteData={(event) => this.handleAutoCompleteData(event, 'physician')}
                                            type="text"
                                            disabled={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                        Npi
                                        </label>
                                        <Field name="Npi" component="input" type="text" disabled={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                            Phone Number
                                        </label>
                                        <Field name="phoneNumber" component="input" type="text" disabled={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                            Speciality
                                        </label>
                                        <Field name="speciality" component="input" type="text" disabled={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                    </div>
                                </div>                               

                                <div className="col-md-2">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                            Next Appointment Date
                                        </label>
                                        <Field name="nextAppointment" minDate={new Date()} component={DatePicker} type="text" isDisable={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                    </div>
                                </div>
                                
                                <div className="col-md-4">
                                    <div className="form__form-group mb-3 ml-1" >
                                        <label className="form__form-group-label">
                                            Note
                                        </label>
                                        <Field name="note" component="textarea" type="text" />
                                    </div>
                                </div>

                                <div className="col-12 p-4">
                                    {this.state.orderDetails && this.state.orderDetails.appoinmentDetails && this.state.orderDetails.appoinmentDetails.length > 0 &&
                                        (this.state.orderDetails.appoinmentDetails).map((data, i) => {
                                            return <div className='row single-scan-encloser mb-4'>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                        Procedure
                                                        </label>
                                                        <Field
                                                            name={`scan-${data._id}`}
                                                            searchApi={'scans'}
                                                            validate={[required]}
                                                            searchField={data.scan ? 'scanDetails' : 'cptCode'}
                                                            component={AutoComplete}
                                                            handleAutoCompleteData={(event) => this.handleAutoCompleteData(event, 'scan')}
                                                            type="text"
                                                            disabled={((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') ? false : true} />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Status
                                                        </label>
                                                        <Field name={`status-${data._id}`} validate={[required]} component={Select} options={this.state.statusOptions} />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                        Modalities
                                                        </label>
                                                        <Field name={`modalities-${data._id}`} validate={[required]} component={Select} placeholder={'Select Modality'} options={this.scanTypes} onChange={(e) => this.onChange(e, `modalities-${data._id}`)} />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Financial class
                                                        </label>
                                                        <Field name={`financialClass-${data._id}`} validate={[required]} component={Select} placeholder={'Select Financial class'} options={this.props.financialClassTypes} onChange={(e) => this.onChangeFinancialClass(e, `${data._id}`)} />
                                                    </div>
                                                </div>
                                                {(this.state.selectedFinancialClasses[`${data._id}`] === 'PIP' ||
                                                 this.state.selectedFinancialClasses[`${data._id}`] === 'Slip & Fall' || 
                                                 this.state.selectedFinancialClasses[`${data._id}`] === 'Workmans Comp')&&
                                                    <div className="col-md-2">
                                                        <div className="form__form-group mb-3 ml-1" >
                                                            <label className="form__form-group-label">
                                                                Date of Injury
                                                            </label>
                                                            <Field maxDate={new Date()} name={`dateOfInjury-${data._id}`} component={DatePicker} type="text" />
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedFinancialClasses[`${data._id}`] === 'PIP' &&
                                                    < div className="col-md-2">
                                                        <div className="form__form-group mb-3 ml-1" >
                                                            <label className="form__form-group-label">
                                                                Policy Number
                                                            </label>
                                                            <Field 
                                                             name={`policyNumber-${data._id}`} 
                                                             component="input" type="text" 
                                                             placeholder="policy Number"
                                                             validate={[required]}
                                                              />
                                                        </div>
                                                    </div>
                                                }

                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Priority
                                                        </label>
                                                        <Field name={`priority-${data._id}`} validate={[required]} component={Select} placeholder={'Select Priority'} options={this.props.priorityTypes} />
                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Facility Staff
                                                        </label>
                                                        <Field
                                                            name={`facilityStaff-${data._id}`}
                                                            searchApi={'facilityemployees'}
                                                            searchField={'displayName'}
                                                            component={AutoComplete}                                                            
                                                            handleAutoCompleteData={(event) => this.handleAutoCompleteData(event, `facilityStaff-${data._id}`)}
                                                            type="text" />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Scheduled Date
                                                        </label>
                                                        <Field minDate={new Date()} name={`scheduledDate-${data._id}`} component={DatePicker} handleDateChange={this.handleDateChange} screen={'Orders'} />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Appointment Time
                                                        </label>
                                                        {/* <Field name={`ScanTime-${data._id}`} component={Select} placeholder={'Select Time'} options={this.state.slotTimes[`-${data._id}`]} /> */}
                                                        <Field name={`ScanTime-${data._id}`} component="select" className="form-control">
                                                            <option value={null}>Select Time</option>
                                                            {this.state.slotTimes[`-${data._id}`] && this.state.slotTimes[`-${data._id}`].length > 0 &&
                                                                this.state.slotTimes[`-${data._id}`].map((elem) => <option value={elem.value}>{elem.label}</option>)
                                                            }
                                                            
                                                        </Field>
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-2">
                                                <div className="form__form-group mb-3 ml-1" >
                                                    <label className="form__form-group-label">
                                                        Scheduled Date
                                                    </label>
                                                    <Field name="scheduledDate" component={DatePicker} type="text" />
                                                </div>
                                            </div> */}
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Scanned Date
                                                        </label>
                                                        <Field minDate={new Date()} name={`scannedDate-${data._id}`} component={DatePicker}  type="text" />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Reviewed Date
                                                        </label>
                                                        <Field minDate={new Date()} name={`reviewedDate-${data._id}`} component={DatePicker} type="text" />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Completed Date
                                                        </label>
                                                        <Field minDate={new Date()} name={`completedDate-${data._id}`} component={DatePicker} type="text" />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Notified Date
                                                        </label>
                                                        <Field minDate={new Date()} name={`notifiedDate-${data._id}`} component={DatePicker} type="text" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form__form-group mb-3 ml-1" >
                                                        <label className="form__form-group-label">
                                                            Note
                                                        </label>
                                                        <Field name={`note-${data._id}`} component="textarea" type="text" />
                                                    </div>
                                                </div>

                                                {(this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee || this.props.pageType === 'add') && this.state.orderDetails.appoinmentDetails.length > 1 &&
                                                    <div className="col align-self-end order-delete-icon">
                                                        <FontAwesomeIcon icon='trash' data-toggle='tooltip' title="Delete" className="cursor-pointer" onClick={() => { this.onClickDeleteScan(data._id,i) }} />
                                                    </div>
                                                }

                                            </div>
                                        }
                                        )}


                                </div>


                            </div>
                            {((this.state.orderDetails.createdBy && this.state.orderDetails.createdBy.facilityemployee) || this.props.pageType === 'add') &&
                                <div className="text-center">
                                    <Button color='primary' type="button" onClick={() => { this.onClickAddScan() }}> <FontAwesomeIcon icon='plus'   />Add Procedure</Button>
                                </div>
                            }


                            <div className="text-right">
                            <a href={`/${this.props.routeTo}`} className='pr-2'><Button color='primary' outline type="button" >Back</Button></a>
                                <Button color='primary' type="submit">Save</Button>
                            </div>



                        </form>
                    }
                </div>
                {this.state.redirectToRoute ? <Redirect to={`/${this.props.routeTo}`} /> : null}
            </div>


        )
    }
}

OrdersEdit = reduxForm({
    form: "OrdersEdit",
    enableReinitialize: true, // a unique identifier for this form
    validate
})(OrdersEdit);

OrdersEdit = connect(
    state => ({
        initialValues: state.commonData.data // pull initial values from account reducer
    }),
    { load: loadAccount } // bind account loading action creator
)(OrdersEdit);

export default withTranslation("common")(OrdersEdit);